import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@views/HomePage.vue"),
    meta: {
      title: "Агентство путешествий",
      description:
        "Организовываем яркие трипы по миру для людей, легких на подъем.",
    },
  },
  {
    path: "/catalog",
    name: "CatalogPage",
    component: () => import("@views/CatalogPage.vue"),
    meta: {
      title: "Каталог туров - Агентство путешествий",
      description: "Изучите наш каталог туров и найдите идеальное путешествие.",
    },
  },
  {
    path: "/tour/:id",
    name: "TourPage",
    component: () => import("@views/TourPage.vue"),
    meta: {
      title: "Детали тура - Агентство путешествий",
      description: "Узнайте больше о маршрутах, длительности и стоимости тура.",
    },
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import("@views/Terms.vue"),
    meta: {
      title: "Условия использования - Агентство путешествий",
      description: "Узнайте больше о наших условиях использования.",
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@views/Privacy.vue"),
    meta: {
      title: "Политика конфиденциальности - Агентство путешествий",
      description: "Ознакомьтесь с нашей политикой конфиденциальности.",
    },
  },
  {
    path: "*",
    name: "NotFoundPage",
    component: () => import("@views/NotFoundPage.vue"),
    meta: {
      title: "404 - Страница не найдена",
      description: "К сожалению, запрашиваемая страница не существует.",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
          resolve({ selector: to.hash });
        }, 300);
      });
    }
    return { x: 0, y: 0 };
  },
});

// Динамическое обновление мета-тегов
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Агентство путешествий";

  const description = document.querySelector("meta[name='description']");
  if (description) {
    description.setAttribute(
      "content",
      to.meta.description ||
        "Агентство путешествий: Организовываем яркие трипы по миру для людей, легких на подъем."
    );
  }

  next();
});

export default router;
